// document.addEventListener('DOMContentLoaded', function () {
  
//   localStorage.clear();
//   const SITE_ID = '5op9sn';
//   const SECTION_ID = 'search-grid-2';
//   const CACHE_DURATION_MINUTES = 5;
//   const RESULTS_PER_PAGE = 9;

//   const pathParts = window.location.pathname.split('/').filter(Boolean);
//   const isCollectionPage = pathParts.includes('collections');
//   const collectionHandle = isCollectionPage ? pathParts[pathParts.indexOf('collections') + 1] : null;
//   if (!isCollectionPage || !collectionHandle) return;

//   const productGrid = document.querySelector('#product-grid-2');
//   if (!productGrid) {
//     console.warn('❗ #product-grid-2 not found — cannot render collection products.');
//     return;
//   }

//   const shopifyRoot = Shopify?.routes?.root || '/';
//   let currentPage = 1;
//   let isFetching = false;
//   let hasMorePages = true;

//   // --- Active State ---
//   var activeFilters = {product_type:[], tags_colour: [], variant_size: [], tags_fabric:[]}; // e.g. { color: ['Blue', 'Green'], size: ['M'] }
//   var activeSort = ''; // e.g. 'price:asc'
//   window.toggleFilter = toggleFilter; // call with toggleFilter('color', 'Blue')
//   window.applySort = applySort; // call with applySort('price', 'asc')
//   window.applyFilter = applyFilter; 
//   // ========================
//   // APPLY URL SORT ON PAGE LOAD
//   // ========================
//   const urlParams = new URLSearchParams(window.location.search);
//   const sortParam = urlParams.get('sort_by');
// // 1️⃣ Handle filters from URL (product_type, variant_size, tags_colour, tags_fabric)
// ['product_type', 'variant_size', 'tags_colour', 'tags_fabric'].forEach(key => {
//   const values = urlParams.getAll(key);
//   if (values.length > 0) {
//     if (!activeFilters[key]) activeFilters[key] = [];
//     values.forEach(v => {
//       activeFilters[key].push(v);
//     });
//   }
// });

//   if (sortParam) {
//     let field = '';
//     let direction = '';

//     switch (sortParam) {
//       case 'manual':
//         field = 'featured';
//         direction = 'desc';
//         break;
//       case 'title-ascending':
//         field = 'title';
//         direction = 'asc';
//         break;
//       case 'title-descending':
//         field = 'title';
//         direction = 'desc';
//         break;
//       case 'price-ascending':
//         field = 'ss_price';
//         direction = 'asc';
//         break;
//       case 'price-descending':
//         field = 'ss_price';
//         direction = 'desc';
//         break;
//       default:
//         field = 'featured';
//         direction = 'desc';
//     }

//     const radioInput = document.querySelector(`input[name="sort_by"][value="${sortParam}"]`);
//     if (radioInput) {
//       radioInput.checked = true;
//     }

//     activeSort = `${field}:${direction}`
//     // console.log(`[Collection] Applied sort from URL: ${sortParam} (${field}:${direction})`);
//   }

//   function toggleFilter(type, value) {
//     if (!activeFilters[type]) activeFilters[type] = [];
//     const index = activeFilters[type].indexOf(value);
//     if (index > -1) {
//       activeFilters[type].splice(index, 1);
//       if (activeFilters[type].length === 0) delete activeFilters[type];
//     } else {
//       activeFilters[type].push(value);
//     }
//     resetCollection();
//   }

//   function applySort(field, direction) {
//     activeSort = `${field}:${direction}`;
//     resetCollection();
//   }
//   function renderSearchspringFilters(facets) {
//   // console.log('facets', facets);
//   const filterContainer = document.querySelector('.filter-wrap');
//   if (!filterContainer) return;

//   // Clear existing filters
//   filterContainer.innerHTML = '';

//   facets.forEach(facet => {
//     // ❌ Skip price or range-type filters
//     if (
//       facet.field === 'ss_price' ||
//       facet.label?.toLowerCase().includes('price') ||
//       facet.type === 'range'
//     ) {
//       return;
//     }

//     // Skip if no values
//     if (!facet.values || facet.values.length === 0) return;

//     // Create facet wrapper with theme classes
//     const facetWrap = document.createElement('div');
//     facetWrap.className = 'facet-list filter-inr filter-index';
//     facetWrap.innerHTML = `
//       <div class="filter-title">
//         <span>${facet.label}</span>
//         <span>
//           <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
//             <path d="M5.262 9.01699L5.262 0.812988L4.03 0.812988L4.03 9.01699L1.076 6.04899L0.291999 6.83299L4.646 11.187L9 6.83299L8.23 6.04899L5.262 9.01699Z" fill="black"></path>
//           </svg>
//         </span>
//       </div>
//       <ul class="filter-inr-wrap"></ul>
//     `;

//     const list = facetWrap.querySelector('.filter-inr-wrap');

//     // Loop through facet values
//     facet.values.forEach(v => {
//       const val = v.value || v.label || `${v.low}-${v.high}` || 'unknown';
//       const safeId = `${facet.field}-${val.replace(/\s+/g, '-').toLowerCase()}`;
//       const isChecked =
//         activeFilters[facet.field] &&
//         activeFilters[facet.field].includes(val);

//       const li = document.createElement('li');
//       li.innerHTML = `
//         <input class="facet-input"
//               type="checkbox"
//               id="${safeId}"
//               name="${facet.field}"
//               value="${val}"
//               ${isChecked ? 'checked' : ''}
//               onchange="toggleFilter('${facet.field}', '${val}')">
//         <label for="${safeId}">${v.label || val}</label>
//       `;
//       list.appendChild(li);
//     });

//     // Append the whole facet block
//     filterContainer.appendChild(facetWrap);
    
//     if (typeof filter_acco == 'function'){
//       filter_acco();
//     }
//     document.querySelectorAll('.filter-title').forEach(function(self){
//         self.addEventListener('click', function(event){
//             self.closest('.filter-index').classList.toggle('active');
//             self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = 'auto';
//         })
//     });
//     // document.querySelectorAll('.filter-title').forEach(function(self){
//     //     self.addEventListener('click', function(event){
//     //         self.closest('.filter-index').classList.toggle('active');
//     //         if (self.closest('.filter-index').classList.contains('active'))
//     //         {
//     //           self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = 'auto';
//     //         } else {
//     //           self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = '0px';
//     //         }
//     //     });
//     //     self.addEventListener('ontouchend', function(event){
//     //         self.closest('.filter-index').classList.toggle('active');
//     //         if (self.closest('.filter-index').classList.contains('active'))
//     //         {
//     //           self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = 'auto';
//     //         } else {
//     //           self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = '0px';
//     //         }
//     //     })
//     // });
//   });
// }
//   function applyFilter() {
//     activeFilters = {product_type:[], tags_colour: [], variant_size: [], tags_fabric:[]}; 
//     setTimeout(function(){
//       document.querySelectorAll('.wc_filter_option:checked').forEach(function(self){
//         var field_value = self.getAttribute('data-param-name');
//         if (field_value.includes('product_type')) {
//           activeFilters.product_type.push(self.value);
//         }
//         if (field_value.includes('filter.v.option.size')) {
//           activeFilters.variant_size.push(self.value);
//         }
//         if (field_value.includes('filter.p.m.custom.color')) {
//           activeFilters.tags_colour.push(self.value);
//         }
//         if (field_value.includes('filter.p.m.custom.fabric')) {
//           activeFilters.tags_fabric.push(self.value);
//         }
//       });
//       resetCollection();
//     }, 500);
//   }

//   function buildSearchspringParams() {
//     let params = [];

//     // Add filters
//     Object.entries(activeFilters).forEach(([key, values]) => {
//       values.forEach(val => {
//         params.push(`filter.${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
//       });
//     });

//     // Add sorting
//     if (activeSort) {
//       const [field, dir] = activeSort.split(':');
//       params.push(`sort.${encodeURIComponent(field)}=${encodeURIComponent(dir)}`);
//     }

//     return params.join('&');
//   }

//   // ========================
//   // LOCAL CACHE HANDLERS
//   // ========================

//   function getCachedProduct(handle) {
//     const cacheKey = `product_html_${handle}`;
//     const cached = localStorage.getItem(cacheKey);
//     if (!cached) return null;
//     const parsed = JSON.parse(cached);
//     const now = Date.now();
//     if (now - parsed.timestamp < CACHE_DURATION_MINUTES * 60 * 1000) {
//       return parsed.html;
//     } else {
//       localStorage.removeItem(cacheKey);
//       return null;
//     }
//   }

//   function setCachedProduct(handle, html) {
//     const cacheKey = `product_html_${handle}`;
//     localStorage.setItem(
//       cacheKey,
//       JSON.stringify({ timestamp: Date.now(), html })
//     );
//   }

//   // ========================
//   // COLLECTION FETCH LOGIC
//   // ========================

//   async function fetchCollectionPage(page = 1) {
//     // console.log('page collection loaded');
//     if (isFetching || !hasMorePages) return;
//     isFetching = true;

//     const loader = document.querySelector('.look-cart-loader-inner');
//     if (loader) loader.style.display = 'flex';

//     try {
//       const extraParams = buildSearchspringParams();
//       const apiURL = `https://${SITE_ID}.a.searchspring.io/api/search/search.json?siteId=${SITE_ID}&resultsFormat=json&bgfilter.collection_handle=${collectionHandle}&page=${page}&resultsPerPage=${RESULTS_PER_PAGE}${
//         extraParams ? '&' + extraParams : ''
//       }`;

//       const response = await fetch(apiURL);
//       const data = await response.json();
//       if (page === 1 && data.facets) {
//         renderSearchspringFilters(data.facets);
//       }
//       if (!data.results || data.results.length === 0) {
//         if (page === 1) productGrid.innerHTML = `<div class="no-results">No products found.</div>`;
//         hasMorePages = false;
//         return;
//       }

//       const handles = data.results.map(p => p.handle).filter(Boolean);
//       const sectionPromises = handles.map(async (handle, index) => {
//       const cachedHTML = getCachedProduct(handle);
//       if (cachedHTML) return { index, html: cachedHTML, handle };

//       try {
//         const res = await fetch(`${shopifyRoot}products/${handle}?sections=${SECTION_ID}`);
//         const json = await res.json();
//         const html = json?.[SECTION_ID];

//         if (!html) {
//           const productData = data.results[index];
//           const fallbackHTML = `
//             <div class="fallback-product">
//               <a href="${shopifyRoot}products/${productData.handle}">
//                 <img src="${productData.imageUrl || productData.image || ''}" alt="${productData.name || ''}" loading="lazy">
//                 <h3>${productData.name || ''}</h3>
//                 <p>${productData.price || ''}</p>
//               </a>
//             </div>`;
//           setCachedProduct(handle, fallbackHTML);
//           return { index, html: fallbackHTML, handle };
//         }

//         setCachedProduct(handle, html);
//         if (!html || html.trim() === '' || html.trim() === `<div id="shopify-section-${SECTION_ID}" class="shopify-section"></div>`) {
//           return { index: ``, html: ``, handle: `` };
//         }else{
//           return { index, html, handle };
//         }
//       } catch (err) {
//         console.warn(`❌ Section fetch failed: ${handle}`, err);
//         return { index, html: ``, handle };
//       }
//     });

//       const sections = await Promise.all(sectionPromises);
//       sections.sort((a, b) => a.index - b.index);
//       const validSections = sections.filter(s => s.html && s.html.trim() !== '');
//       const combinedHTML = validSections.map(({ html }) => `<div class="product-item">${html}</div>`).join('');

//       if (combinedHTML.trim() !== '') {
//         productGrid.insertAdjacentHTML('beforeend', combinedHTML);
//       } else {
//         console.warn('⚠️ No valid product HTML found to insert.');
//       }
//       // const combinedHTML = sections.map(({ html }) => `<div class="product-item">${html}</div>`).join('');
//       // productGrid.insertAdjacentHTML('beforeend', combinedHTML);

//       $th_refreshWishlistItems?.();
//       quickAddButton2();
//       colorVariantClick2();
      
//       // console.log(`[Collection] Rendered page ${page} (${sections.length} products)`);
//       document.querySelector('.collection-grid.placeholder-grid').style.display = 'none';
//       if (data.pagination.currentPage == data.pagination.totalPages) {
//         document.querySelector('#AjaxinatePagination').style.display = 'none';
//       }
//       if (!data.pagination?.nextPage) hasMorePages = false;
//       currentPage++;
//     } catch (err) {
//       // console.error('❌ Error fetching collection products:', err);
//       if (currentPage === 1) {
//         productGrid.innerHTML = ``;
//       }
//     } finally {
//       isFetching = false;
//       if (loader) setTimeout(() => (loader.style.display = 'none'), 100);
//     }
//   }

//   // ========================
//   // PAGINATION / SCROLL
//   // ========================
//   window.addEventListener('scroll', () => {
//     if (isFetching || !hasMorePages) return;
//     const scrollY = window.scrollY + window.innerHeight;
//     const threshold = document.body.offsetHeight - 1000;
//     if (scrollY >= threshold) fetchCollectionPage(currentPage);
//   });

//   function resetCollection() {
//     // console.log('reset called');
//     productGrid.innerHTML = '';
//     currentPage = 1;
//     hasMorePages = true;
//     fetchCollectionPage(currentPage);
//   }

//   // ========================
//   // INITIAL LOAD
//   // ========================
//   fetchCollectionPage(currentPage);

//   // ========================
//   // QUICK ADD + COLOR VARIANT
//   // ========================
//   function quickAddButton2() {
//     document.querySelectorAll('.variant-grid').forEach(sizeList => {
//       sizeList.addEventListener('click', e => {
//         e.preventDefault();
//         const variant_id = sizeList.dataset.id;
//         const formData = { items: [{ id: variant_id, quantity: 1 }] };
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(formData),
//         })
//           .then(r => r.json())
//           .then(() => {
//             if (typeof load_cart === 'function') load_cart();
//           })
//           .catch(console.error);
//       });
//     });
//   }

//   function colorVariantClick2() {
//     if (window.innerWidth > 1024) {
//       document.querySelectorAll('.grid-bottom .main-color-variant .color-var.click').forEach(function (element) {
//         element.addEventListener('click', function (event) {
//           event.preventDefault();
//           const attVal = this.getAttribute('data-id');
//           const productItem = this.closest('.product-item');
//           if (!productItem) return;

//           const innerGrids = productItem.querySelectorAll('.snippet-product-grid .inner-product-grid');
//           innerGrids.forEach(function (innerGrid) {
//             if (attVal === innerGrid.getAttribute('data-id')) {
//               innerGrids.forEach(g => g.classList.remove('active'));
//               innerGrid.classList.add('active');
//             }
//           });
//         });
//       });
//     }
//   }
// });

// //  document.querySelectorAll('.filter-title').forEach(function(self){
// //         self.addEventListener(['ontouchend', 'click'], function(event){
// //             self.closest('.filter-index').classList.toggle('active');
// //             self.closest('.filter-index').querySelector('.filter-inr-wrap').style.height = 'auto';
// //         })
// //     });

// // if (window.innerWidth < 1224) {
// //   filter_acco();
// // }


document.addEventListener('DOMContentLoaded', function () {

  // Only clear collection-specific cache, not all localStorage
  const SITE_ID = '5op9sn';
  const SECTION_ID = 'search-grid-2';
  const CACHE_DURATION_MINUTES = 5;
  const RESULTS_PER_PAGE = 9;
  
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const isCollectionPage = pathParts.includes('collections');
  const collectionHandle = isCollectionPage ? pathParts[pathParts.indexOf('collections') + 1] : null;
  
  console.log('🔍 Collection Detection:', {
    isCollectionPage,
    collectionHandle,
    pathname: window.location.pathname
  });
  
  if (!isCollectionPage || !collectionHandle) {
    console.warn('❌ Not a collection page or no handle found');
    return;
  }

  const productGrid = document.querySelector('#product-grid-2');
  if (!productGrid) {
    console.warn('❗ #product-grid-2 not found — cannot render collection products.');
    return;
  }

  const shopifyRoot = Shopify?.routes?.root || '/';
  let currentPage = 1;
  let isFetching = false;
  let hasMorePages = true;
  let totalProductCount = 0;
  let featuredSectionIndex = 0;

  // --- Featured Grids Configuration ---
  let featuredGridsConfig = [];
  try {
    const featuredGridsData = productGrid.dataset.featuredGrids || productGrid.getAttribute('data-featured-grids');
    const blocksCount = productGrid.getAttribute('data-featured-grid-blocks-count') || '0';
    
    console.log('🔍 Featured Grids Check:', {
      hasDataAttribute: !!featuredGridsData,
      dataLength: featuredGridsData ? featuredGridsData.length : 0,
      blocksCount: blocksCount,
      rawData: featuredGridsData
    });
    
    if (featuredGridsData && featuredGridsData !== '[]' && featuredGridsData.trim() !== '') {
      try {
        featuredGridsConfig = JSON.parse(featuredGridsData);
        console.log('✅ Successfully parsed featured grids:', featuredGridsConfig);
        
        // Validate each config
        featuredGridsConfig = featuredGridsConfig.filter(config => {
          const hasCollection = config.collection_handle && config.collection_handle.trim() !== '';
          const hasImage = config.image_url && config.image_url.trim() !== '';
          const hasVideo = config.video_url && config.video_url.trim() !== '';
          const hasMedia = hasImage || hasVideo;
          const isValid = hasCollection && hasMedia;
          if (!isValid) {
            console.warn('⚠️ Filtering out invalid config:', config);
          }
          return isValid;
        });
        
        featuredGridsConfig.sort((a, b) => a.position - b.position);
        console.log(`📊 Valid featured grids: ${featuredGridsConfig.length}`, featuredGridsConfig);
      } catch (parseErr) {
        console.error('❌ JSON parse error:', parseErr);
        featuredGridsConfig = [];
      }
    } else {
      console.log('ℹ️ No featured grids data found');
    }
  } catch (err) {
    console.error('❌ Failed to parse featured grids configuration:', err);
    featuredGridsConfig = [];
  }

  const usedFeaturedGrids = new Set();

  // Clear only this collection's cache
  const cacheKey = `collection_cache_${collectionHandle}`;
  sessionStorage.removeItem(cacheKey);
  console.log('🔄 Collection cache cleared for:', collectionHandle);

  // --- Active State ---
  var activeFilters = { product_type: [], tags_colour: [], variant_size: [], tags_fabric: [] };
  var activeSort = '';

  window.toggleFilter = toggleFilter;
  window.applySort = applySort;
  window.applyFilter = applyFilter;

  // ========================
  // APPLY URL SORT ON PAGE LOAD
  // ========================
  const urlParams = new URLSearchParams(window.location.search);
  const sortParam = urlParams.get('sort_by');

  ['product_type', 'variant_size', 'tags_colour', 'tags_fabric'].forEach(key => {
    const values = urlParams.getAll(key);
    if (values.length > 0) {
      if (!activeFilters[key]) activeFilters[key] = [];
      values.forEach(v => {
        activeFilters[key].push(v);
      });
    }
  });

  if (sortParam) {
    let field = '';
    let direction = '';

    switch (sortParam) {
      case 'manual':
        field = 'featured';
        direction = 'desc';
        break;
      case 'title-ascending':
        field = 'title';
        direction = 'asc';
        break;
      case 'title-descending':
        field = 'title';
        direction = 'desc';
        break;
      case 'price-ascending':
        field = 'ss_price';
        direction = 'asc';
        break;
      case 'price-descending':
        field = 'ss_price';
        direction = 'desc';
        break;
      default:
        field = 'featured';
        direction = 'desc';
    }

    const radioInput = document.querySelector(`input[name="sort_by"][value="${sortParam}"]`);
    if (radioInput) radioInput.checked = true;

    activeSort = `${field}:${direction}`;
  }

  function toggleFilter(type, value) {
    if (!activeFilters[type]) activeFilters[type] = [];
    const index = activeFilters[type].indexOf(value);
    if (index > -1) {
      activeFilters[type].splice(index, 1);
      if (activeFilters[type].length === 0) delete activeFilters[type];
    } else {
      activeFilters[type].push(value);
    }
    resetCollection();
  }

  function applySort(field, direction) {
    activeSort = `${field}:${direction}`;
    resetCollection();
  }

  function renderSearchspringFilters(facets) {
    const filterContainer = document.querySelector('.filter-wrap');
    if (!filterContainer) return;

    filterContainer.innerHTML = '';

    facets.forEach(facet => {
      if (
        facet.field === 'ss_price' ||
        facet.label?.toLowerCase().includes('price') ||
        facet.type === 'range'
      ) {
        return;
      }

      if (!facet.values || facet.values.length === 0) return;

      const facetWrap = document.createElement('div');
      facetWrap.className = 'facet-list filter-inr filter-index';
      facetWrap.innerHTML = `
        <div class="filter-title">
          <span>${facet.label}</span>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
              <path d="M5.262 9.01699L5.262 0.812988L4.03 0.812988L4.03 9.01699L1.076 6.04899L0.291999 6.83299L4.646 11.187L9 6.83299L8.23 6.04899L5.262 9.01699Z" fill="black"></path>
            </svg>
          </span>
        </div>
        <ul class="filter-inr-wrap"></ul>
      `;

      const list = facetWrap.querySelector('.filter-inr-wrap');

      let values = facet.values;

      if (facet.field === 'variant_size') {
        const sizeOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'OS'];

        const alphaSizes = [];
        const numericSizes = [];
        const others = [];

        values.forEach(v => {
          const val = (v.value || v.label || '').toUpperCase().trim();
          if (sizeOrder.includes(val)) {
            alphaSizes.push(v);
          } else if (/^[0-9]+$/.test(val)) {
            numericSizes.push(v);
          } else {
            others.push(v);
          }
        });

        alphaSizes.sort((a, b) => {
          const va = (a.value || a.label || '').toUpperCase();
          const vb = (b.value || b.label || '').toUpperCase();
          return sizeOrder.indexOf(va) - sizeOrder.indexOf(vb);
        });

        numericSizes.sort((a, b) => parseInt(a.value) - parseInt(b.value));
        others.sort((a, b) => (a.label || '').localeCompare(b.label || ''));

        values = [...alphaSizes, ...numericSizes, ...others];
      }

      values.forEach(v => {
        const val = v.value || v.label || `${v.low}-${v.high}` || 'unknown';
        const safeId = `${facet.field}-${val.replace(/\s+/g, '-').toLowerCase()}`;
        const isChecked =
          activeFilters[facet.field] && activeFilters[facet.field].includes(val);

        const li = document.createElement('li');
        li.innerHTML = `
          <input class="facet-input"
                type="checkbox"
                id="${safeId}"
                name="${facet.field}"
                value="${val}"
                ${isChecked ? 'checked' : ''}
                onchange="toggleFilter('${facet.field}', '${val}')">
          <label for="${safeId}">${v.label || val}</label>
        `;
        list.appendChild(li);
      });

      filterContainer.appendChild(facetWrap);
    });
    
    setTimeout(() => {
      if (typeof filter_accod === 'function') filter_accod();
      if (typeof ensureGridImagesUpdate === 'function') ensureGridImagesUpdate();
    }, 300);
  }

  function applyFilter() {
    activeFilters = { product_type: [], tags_colour: [], variant_size: [], tags_fabric: [] };
    setTimeout(function () {
      document.querySelectorAll('.wc_filter_option:checked').forEach(function (self) {
        var field_value = self.getAttribute('data-param-name');
        if (field_value.includes('product_type')) {
          activeFilters.product_type.push(self.value);
        }
        if (field_value.includes('filter.v.option.size')) {
          activeFilters.variant_size.push(self.value);
        }
        if (field_value.includes('filter.p.m.custom.color')) {
          activeFilters.tags_colour.push(self.value);
        }
        if (field_value.includes('filter.p.m.custom.fabric')) {
          activeFilters.tags_fabric.push(self.value);
        }
      });
      resetCollection();
    }, 500);
  }

  function buildSearchspringParams() {
    let params = [];

    Object.entries(activeFilters).forEach(([key, values]) => {
      values.forEach(val => {
        params.push(`filter.${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
      });
    });

    if (activeSort) {
      const [field, dir] = activeSort.split(':');
      params.push(`sort.${encodeURIComponent(field)}=${encodeURIComponent(dir)}`);
    }

    return params.join('&');
  }

  function getCachedProduct(handle) {
    const cacheKey = `product_html_${handle}`;
    const cached = localStorage.getItem(cacheKey);
    if (!cached) return null;
    const parsed = JSON.parse(cached);
    const now = Date.now();
    if (now - parsed.timestamp < CACHE_DURATION_MINUTES * 60 * 1000) {
      return parsed.html;
    } else {
      localStorage.removeItem(cacheKey);
      return null;
    }
  }

  function setCachedProduct(handle, html) {
    const cacheKey = `product_html_${handle}`;
    localStorage.setItem(
      cacheKey,
      JSON.stringify({ timestamp: Date.now(), html })
    );
  }

  // ========================
  // FEATURED VIDEO INITIALIZATION
  // ========================
  function initFeaturedVideos() {
    const featuredVideos = document.querySelectorAll('.featured-section .featured-video');
    
    if (featuredVideos.length === 0) return;
    
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting) {
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(error => {
                console.log('Video autoplay prevented:', error);
              });
            }
          } else {
            video.pause();
          }
        });
      }, {
        threshold: 0.25
      });
      
      featuredVideos.forEach(video => {
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('muted', '');
        video.setAttribute('preload', 'metadata');
        
        videoObserver.observe(video);
      });
    } else {
      featuredVideos.forEach(video => {
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('muted', '');
        video.setAttribute('preload', 'metadata');
        
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log('Video autoplay prevented:', error);
          });
        }
      });
    }
  }

  // ========================
  // COLLECTION FETCH LOGIC WITH FEATURED GRIDS
  // ========================
  async function fetchCollectionPage(page = 1) {
    if (isFetching || !hasMorePages) {
      console.log(`⏸️ Skipping fetch - isFetching: ${isFetching}, hasMorePages: ${hasMorePages}`);
      return;
    }
    isFetching = true;

    const loader = document.querySelector('.look-cart-loader-inner');
    if (loader) loader.style.display = 'flex';

    try {
      const extraParams = buildSearchspringParams();
      const apiURL = `https://${SITE_ID}.a.searchspring.io/api/search/search.json?siteId=${SITE_ID}&resultsFormat=json&bgfilter.collection_handle=${collectionHandle}&page=${page}&resultsPerPage=${RESULTS_PER_PAGE}${extraParams ? '&' + extraParams : ''}`;

      console.log(`🌐 Fetching page ${page}:`, apiURL);
      
      const response = await fetch(apiURL);
      
      console.log(`📡 Response status:`, response.status, response.statusText);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      
      console.log(`📦 API Response:`, {
        page: page,
        totalResults: data.results?.length || 0,
        pagination: data.pagination
      });
      
      if (page === 1 && data.facets) {
        renderSearchspringFilters(data.facets);
      }
      
      if (!data.results || data.results.length === 0) {
        console.warn(`⚠️ No results returned for page ${page}`);
        if (page === 1) {
          productGrid.innerHTML = `<div class="no-results">No products found.</div>`;
        }
        hasMorePages = false;
        return;
      }

      const handles = data.results.map(p => p.handle).filter(Boolean);
      console.log(`📋 Product handles (${handles.length}):`, handles);
      
      const sectionPromises = handles.map(async (handle, index) => {
        const cachedHTML = getCachedProduct(handle);
        if (cachedHTML) {
          return { index, html: cachedHTML, handle };
        }

        try {
          const productURL = `${shopifyRoot}products/${handle}?sections=${SECTION_ID}`;
          const res = await fetch(productURL);
          
          if (!res.ok) {
            throw new Error(`HTTP ${res.status}`);
          }
          
          const json = await res.json();
          const html = json?.[SECTION_ID];

          if (!html || html.trim() === '' || html.trim() === `<div id="shopify-section-${SECTION_ID}" class="shopify-section"></div>`) {
            const productData = data.results[index];
            const fallbackHTML = `
              <div class="fallback-product">
                <a href="${shopifyRoot}products/${productData.handle}">
                  <img src="${productData.imageUrl || productData.image || ''}" alt="${productData.name || ''}" loading="lazy">
                  <h3>${productData.name || ''}</h3>
                  <p>${productData.price || ''}</p>
                </a>
              </div>`;
            setCachedProduct(handle, fallbackHTML);
            return { index, html: fallbackHTML, handle };
          }

          setCachedProduct(handle, html);
          return { index, html, handle };
        } catch (err) {
          console.error(`❌ Section fetch failed for ${handle}:`, err);
          const productData = data.results[index];
          const fallbackHTML = `
            <div class="fallback-product error">
              <a href="${shopifyRoot}products/${productData.handle}">
                <img src="${productData.imageUrl || productData.image || ''}" alt="${productData.name || ''}" loading="lazy">
                <h3>${productData.name || ''}</h3>
                <p>View Product</p>
              </a>
            </div>`;
          return { index, html: fallbackHTML, handle };
        }
      });

      const sections = await Promise.all(sectionPromises);
      sections.sort((a, b) => a.index - b.index);
      
      const validSections = sections.filter(s => s.html && s.html.trim() !== '');
      
      console.log(`✅ Valid sections to render: ${validSections.length}`);
      
      // ========================
      // FEATURED GRID INSERTION LOGIC
      // ========================
      const isMobile = window.innerWidth <= 1024;
      
      function shouldInsertFeaturedSection(currentPosition) {
        if (featuredGridsConfig.length === 0) {
          return null;
        }
        
        console.log(`🔍 [Position ${currentPosition}] Checking featured grids (${isMobile ? 'mobile' : 'desktop'})`);
        
        for (const gridConfig of featuredGridsConfig) {
          const configKey = `${gridConfig.collection_handle}_${gridConfig.position}_${gridConfig.mobile_position}`;
          
          if (usedFeaturedGrids.has(configKey)) {
            continue;
          }
          
          const targetPosition = isMobile ? gridConfig.mobile_position : gridConfig.position;
          
          console.log(`   Comparing position ${currentPosition} with target ${targetPosition}`);
          
          if (currentPosition === targetPosition) {
            console.log(`✅ MATCH! Inserting featured grid at position ${currentPosition}`);
            return gridConfig;
          }
        }
        return null;
      }
      
      let htmlToInsert = '';
      let i = 0;
      let productsInserted = 0;
      
      const productsPerRow = isMobile ? 2 : 4;
      
      const existingRegularProducts = Array.from(productGrid.children).filter(child => 
        child.classList.contains('product-item')
      ).length;
      let regularProductCount = existingRegularProducts;
      let gridPosition = existingRegularProducts % productsPerRow;
      
      console.log(`🚀 Starting insertion:`, {
        validSections: validSections.length,
        existingRegularProducts: existingRegularProducts,
        initialGridPosition: gridPosition,
        productsPerRow: productsPerRow,
        featuredGridsConfigured: featuredGridsConfig.length,
        isMobile: isMobile
      });
      
      while (i < validSections.length) {
        const currentIndex = regularProductCount;
        
        const featuredGridConfig = shouldInsertFeaturedSection(currentIndex);
        
        if (featuredGridConfig) {
          const configKey = `${featuredGridConfig.collection_handle}_${featuredGridConfig.position}_${featuredGridConfig.mobile_position}`;
          usedFeaturedGrids.add(configKey);
          
          const productsRemaining = validSections.length - i;
          
          if (productsRemaining < 4) {
            console.warn(`⚠️ Not enough products (${productsRemaining}) for featured section - need 4. Continuing with regular products.`);
          } else {
            const product1HTML = validSections[i].html;
            const product2HTML = validSections[i + 1].html;
            const product3HTML = validSections[i + 2].html;
            const product4HTML = validSections[i + 3].html;
            
            const mediaType = featuredGridConfig.media_type || 'image';
            let imageUrl = featuredGridConfig.image_url || '';
            const imageAlt = featuredGridConfig.image_alt || '';
            let videoUrl = featuredGridConfig.video_url || '';
            let videoSources = featuredGridConfig.video_sources || null;
            const customUrl = featuredGridConfig.url || '';
            
            if (imageUrl && imageUrl.startsWith('//')) {
              imageUrl = `https:${imageUrl}`;
            }
            
            if (videoUrl && videoUrl.startsWith('//')) {
              videoUrl = `https:${videoUrl}`;
            }
            
            let mediaHTML = '';
            
            if (mediaType === 'video' && (videoUrl || videoSources)) {
              let videoTag = '';
              
              let parsedVideoSources = null;
              if (videoSources) {
                if (typeof videoSources === 'string') {
                  try {
                    parsedVideoSources = JSON.parse(videoSources);
                  } catch (e) {
                    console.warn('Failed to parse video sources:', e);
                  }
                } else if (Array.isArray(videoSources)) {
                  parsedVideoSources = videoSources;
                }
              }
              
              if (parsedVideoSources && Array.isArray(parsedVideoSources) && parsedVideoSources.length > 0) {
                const sourceTags = parsedVideoSources.map(source => {
                  const src = source.url || source.src || '';
                  const type = source.mime_type || source.type || 'video/mp4';
                  if (src) {
                    return `<source src="${src}" type="${type}">`;
                  }
                  return '';
                }).filter(tag => tag !== '').join('');
                
                if (sourceTags) {
                  videoTag = `<video autoplay muted loop playsinline preload="metadata" style="width: 100%; height: 100%; object-fit: cover; background: #000;" class="featured-video">${sourceTags}</video>`;
                }
              }
              
              if (!videoTag && videoUrl && videoUrl.trim() !== '') {
                videoTag = `<video src="${videoUrl}" autoplay muted loop playsinline preload="metadata" style="width: 100%; height: 100%; object-fit: cover; background: #000;" class="featured-video"></video>`;
              }
              
              if (videoTag) {
                if (customUrl && customUrl.trim() !== '') {
                  mediaHTML = `<a href="${customUrl}" class="featured-media-link">${videoTag}</a>`;
                } else {
                  mediaHTML = videoTag;
                }
              }
            }
            
            if (!mediaHTML && imageUrl) {
              if (customUrl && customUrl.trim() !== '') {
                mediaHTML = `<a href="${customUrl}" class="featured-image-link"><img src="${imageUrl}" alt="${imageAlt}" loading="lazy" style="width: 100%; height: 100%; object-fit: cover;"></a>`;
              } else {
                mediaHTML = `<img src="${imageUrl}" alt="${imageAlt}" loading="lazy" style="width: 100%; height: 100%; object-fit: cover;">`;
              }
            }
            
            const isPositionZero = currentIndex === 0;
            
            if (isMobile) {
              if (mediaHTML) {
                const positionClass = isPositionZero ? 'position-zero' : '';
                const featuredHTML = `
                  <div class="featured-section ${positionClass}">
                    <div class="product-item featured-2x2">${mediaHTML}</div>
                  </div>`;
                htmlToInsert += featuredHTML;
                productsInserted += 1;
                gridPosition = 0;
                i += 4;
                console.log(`✅ Mobile featured section inserted`);
              }
            } else {
              if (mediaHTML && product1HTML && product2HTML && product3HTML && product4HTML) {
                const isRightSide = featuredGridConfig.layout === 'right';
                const positionClass = isPositionZero ? 'position-zero' : '';
                const sectionClass = isRightSide ? `featured-section featured-right ${positionClass}` : `featured-section featured-left ${positionClass}`;
                
                let featuredHTML = '';
                if (isRightSide) {
                  featuredHTML = `
                    <div class="${sectionClass}">
                      <div class="product-item">${product1HTML}</div>
                      <div class="product-item">${product2HTML}</div>
                      <div class="product-item featured-2x2">${mediaHTML}</div>
                      <div class="product-item">${product3HTML}</div>
                      <div class="product-item">${product4HTML}</div>
                    </div>`;
                } else {
                  featuredHTML = `
                    <div class="${sectionClass}">
                      <div class="product-item featured-2x2">${mediaHTML}</div>
                      <div class="product-item">${product1HTML}</div>
                      <div class="product-item">${product2HTML}</div>
                      <div class="product-item">${product3HTML}</div>
                      <div class="product-item">${product4HTML}</div>
                    </div>`;
                }
                
                htmlToInsert += featuredHTML;
                productsInserted += 5;
                featuredSectionIndex++;
                i += 4;
                gridPosition = 0;
                console.log(`✅ Desktop featured section inserted (${isRightSide ? 'right' : 'left'} layout)`);
              }
            }
          }
        } else {
          // Regular product insertion
          const isEndOfRow = (gridPosition + 1) % productsPerRow === 0;
          const itemClass = isEndOfRow ? 'product-item no-right-border' : 'product-item';
          
          htmlToInsert += `<div class="${itemClass}">${validSections[i].html}</div>`;
          i++;
          productsInserted++;
          regularProductCount++;
          gridPosition = (gridPosition + 1) % productsPerRow;
        }
      }

      console.log(`💾 Final: inserting ${productsInserted} items`);

      if (htmlToInsert.trim() !== '') {
        productGrid.insertAdjacentHTML('beforeend', htmlToInsert);
        totalProductCount += productsInserted;
      }

      if (typeof $th_refreshWishlistItems === 'function') $th_refreshWishlistItems();
      quickAddButton2();
      colorVariantClick2();
      
      // Initialize videos after inserting
      setTimeout(initFeaturedVideos, 500);

      document.querySelector('.collection-grid.placeholder-grid')?.style?.setProperty('display', 'none');
      if (data.pagination && data.pagination.currentPage == data.pagination.totalPages) {
        document.querySelector('#AjaxinatePagination')?.style?.setProperty('display', 'none');
      }
      if (!data.pagination?.nextPage) hasMorePages = false;
      currentPage++;
      
      console.log(`✅ Page ${page} complete. Next: ${currentPage}, Has more: ${hasMorePages}`);
      
    } catch (err) {
      console.error('❌ CRITICAL ERROR:', err);
      
      if (currentPage === 1) {
        productGrid.innerHTML = `
          <div class="error" style="padding: 20px; text-align: center;">
            <h3>Error loading products</h3>
            <p>Error: ${err.message}</p>
          </div>`;
      }
    } finally {
      isFetching = false;
      if (loader) setTimeout(() => (loader.style.display = 'none'), 100);
    }
  }

  // ========================
  // RESPONSIVE BREAKPOINT HANDLER
  // ========================
  let currentViewportIsMobile = window.innerWidth <= 1024;
  let resizeTimeout = null;

  function handleResize() {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }

    resizeTimeout = setTimeout(() => {
      if (isFetching) {
        setTimeout(handleResize, 500);
        return;
      }

      const newViewportIsMobile = window.innerWidth <= 1024;
      
      if (currentViewportIsMobile !== newViewportIsMobile) {
        console.log(`🔄 Breakpoint crossed: ${currentViewportIsMobile ? 'mobile' : 'desktop'} → ${newViewportIsMobile ? 'mobile' : 'desktop'}`);
        currentViewportIsMobile = newViewportIsMobile;
        resetCollection();
      }
    }, 250);
  }

  window.addEventListener('resize', handleResize);

  // ========================
  // PAGINATION / SCROLL
  // ========================
  window.addEventListener('scroll', () => {
    if (isFetching || !hasMorePages) return;
    const scrollY = window.scrollY + window.innerHeight;
    const threshold = document.body.offsetHeight - 1000;
    if (scrollY >= threshold) fetchCollectionPage(currentPage);
  });

  function resetCollection() {
    console.log('🔄 Resetting collection');
    productGrid.innerHTML = '';
    currentPage = 1;
    hasMorePages = true;
    totalProductCount = 0;
    featuredSectionIndex = 0;
    usedFeaturedGrids.clear();
    sessionStorage.removeItem(cacheKey);
    fetchCollectionPage(currentPage);
  }

  // ========================
  // INITIAL LOAD
  // ========================
  console.log('🚀 Starting initial collection load');
  fetchCollectionPage(currentPage);

  // ========================
  // QUICK ADD + COLOR VARIANT
  // ========================
  function quickAddButton2() {
    document.querySelectorAll('.variant-grid').forEach(sizeList => {
      sizeList.addEventListener('click', e => {
        e.preventDefault();
        const variant_id = sizeList.dataset.id;
        const formData = { items: [{ id: variant_id, quantity: 1 }] };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        })
          .then(r => r.json())
          .then(() => {
            if(typeof load_cart == 'function'){
              load_cart();
              setTimeout(function(e){
                document.querySelector('body').classList.add('open-drawer');
              },2000);
            }else{
              window.location.href = "/cart";
            }
          })
          .catch(console.error);
      });
    });
  }

  function colorVariantClick2() {
    if (window.innerWidth > 1024) {
      document.querySelectorAll('.grid-bottom .main-color-variant .color-var.click').forEach(function (element) {
        element.addEventListener('click', function (event) {
          event.preventDefault();
          const attVal = this.getAttribute('data-id');
          const productItem = this.closest('.product-item');
          if (!productItem) return;

          const innerGrids = productItem.querySelectorAll('.snippet-product-grid .inner-product-grid');
          innerGrids.forEach(function (innerGrid) {
            if (attVal === innerGrid.getAttribute('data-id')) {
              innerGrids.forEach(g => g.classList.remove('active'));
              innerGrid.classList.add('active');
            }
          });
        });
      });
    }
  }
});